import {IPaytable} from '@fantasmagames/slot/src/logic/Logic';
import {HTMLPageView} from '@fantasmagames/core/src/html/HTMLPageView';
import {SymbolPayouts, Symbols} from '../reels/Symbols';
import {ReelConstants} from '@fantasmagames/slot/src/modules/reels/ReelConstants';

export interface IHTMLSymbolPayoutMap {
	[symbolId: number]: IHTMLSymbolPayoutValues;
}

export interface IHTMLSymbolPayoutValues {
	[count: number]: HTMLElement;
}

export class PaytableView extends HTMLPageView {
	protected _symbolHMTLPayoutMap: IHTMLSymbolPayoutMap;

	protected _paytableValues: IPaytable;
	protected _multiplier: number = 1;

	public init(): void {
		this.initPaytableMap();

		super.init();
	}

	protected setupPathsAndIds(): void {
		this._resourcesPath = 'HTML/PAYTABLE/';
		this._containerId = 'FANTASMA_PAYTABLE_CONTAINER';
	}

	protected onDivComplete(): void {
		super.onDivComplete();
	}

	protected getBodyContent(): string {
		return this.resources.getPaytableHTML();
	}

	protected getIframeContent(): string {
		return this.resources.getPaytableHTML();
	}

	protected initPaytableMap(): void {
		this._symbolHMTLPayoutMap = {};

		for (const symId in Symbols) {
			if (Symbols.hasOwnProperty(symId)) {
				this._symbolHMTLPayoutMap[Symbols[symId]] = [];
			}
		}
	}

	public updatePaytable(multiplier: number): void {
		// After running once, store DOM references in map.
		this._multiplier = multiplier;

		if (this._hasLoaded) {
			const syms = [];

			for (let sym = Symbols.WR; sym <= Symbols.F10; sym++) {
				syms.push(sym);
			}

			for (const sym of syms) {
				const symId = Symbols[sym];

				for (let count = 3; count <= ReelConstants.REELS_AMOUNT; count++) {
					const element = this.getSymbolElement(symId, count);
					let value = this.truncValue(this.getSymbolValue(sym, count) * this._multiplier).toString();

					value = this.currencyFormatter.formatCurrency(value, true);

					element.innerText = value;
				}
			}
		}
	}

	protected truncValue(value: number): number {
		return Math.floor(value * 100) / 100;
	}

	private getSymbolValue(symId: number, count: number): number {
		return SymbolPayouts.paytable[symId].values[count];
	}

	protected getSymbolElement(symbolId: string, count: number): HTMLElement {
		if (this._symbolHMTLPayoutMap[Symbols[symbolId]] && this._symbolHMTLPayoutMap[Symbols[symbolId]][count]) {
			return this._symbolHMTLPayoutMap[Symbols[symbolId]][count];
		}

		// if (this.device.iOS || this.device.iPad) {
		this._symbolHMTLPayoutMap[Symbols[symbolId]][count] = this._mainContainer.ownerDocument.getElementById(`${symbolId}_${count}`);
		// } else {
		// 	this._symbolHMTLPayoutMap[Symbols[symbolId]][count] = this._mainIframe.contentDocument.getElementById(`${symbolId}_${count}`);
		// }

		return this._symbolHMTLPayoutMap[Symbols[symbolId]][count];
	}

	public set paytableValues(newValues: IPaytable) {
		this._paytableValues = newValues;
	}

	public get paytableValues(): IPaytable {
		return this._paytableValues;
	}
}



// WEBPACK FOOTER //
// ./src/paytable/PaytableView.ts